export default __webpack_public_path__ + "static/media/logo_bim_share_b.ffcd093c.png";